import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { css } from "styled-components";

productDescriptionStyles.productDetailLink = {
	css: css`
		span{
			font-size: 16px;
		}
    `,
}